import { Injectable } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class P2UpdateTableService {
    constructor(private datatask: DataTaskService) {}

    public async getSettings(): Promise<P2UpdateTablesSettingsGet> {
        return (await this.datatask.Post(1401))[0];
    }

    public async listUpdateTables(): Promise<P2UpdateTableItem[]> {
        return this.datatask.Post(204);
    }

    public async getUpdateTable(params: GetP2UpdateTableParams): Promise<P2UpdateTableGet> {
        return (await this.datatask.Post(205, params))[0];
    }

    public async saveUpdateTable(table: P2UpdateTableGet): Promise<void> {
        await this.datatask.Post(206, table);
    }
}

export interface P2UpdateTablesSettingsGet {
    filtervalue: string;
}

export interface P2UpdateTableItem extends Item {
    item_state?: string;
}

export interface GetP2UpdateTableParams {
    p2_updatetable_keyno: string;
}

export interface P2UpdateTableGet extends Record<string, unknown> {
    p2_updatetable_keyno: string;
    table_name: string;
    sync_data: '1' | '0';
    hashinfo: string;
    update_order: number;
    reg_datetime: string;
    sync_use_load: '1' | '0';
}
